import { captureMessage } from '@sentry/react'
import { useLocation, useParams } from 'react-router'

import usePrequalStore from 'app/data/prequalStore'
import { useApiPersonalLoan } from 'app/hooks/useApi'
import { ROUTES } from 'app/utils/constants'

/**
 * Custom hook that provides a function to save language preference
 * Only saves when user is in personal loan flow and has an application ID
 */
export default function useLanguagePreferenceSaver() {
    const location = useLocation()
    const { applicationId } = useParams()
    const { saveLanguagePreference } = useApiPersonalLoan()
    const { updateLoanInfo } = usePrequalStore()

    const saveLanguagePreferenceInOrigination = async (language: string) => {
        const isInPersonalLoanFlow = location.pathname.startsWith(ROUTES.PERSONAL_LOAN)

        if (isInPersonalLoanFlow && applicationId) {
            try {
                await saveLanguagePreference(applicationId, {
                    language_preference: language
                })
            } catch (error) {
                captureMessage('Failed to save language preference', {
                    level: 'error',
                    extra: {
                        error,
                        applicationId
                    }
                })
                // Don't throw - let language change proceed regardless of API status
            }
        }
    }

    const saveLanguagePreferenceInPrequal = async (language: string) => {
        const isInPrequalFlow = location.pathname.startsWith(ROUTES.PREQUAL)

        if (isInPrequalFlow) {
            updateLoanInfo({ languagePreference: language })
        }
    }

    return { saveLanguagePreferenceInOrigination, saveLanguagePreferenceInPrequal }
}
